// extracted by mini-css-extract-plugin
module.exports = {"login":"LoginUser_login__3DPaG","input":"LoginUser_input__3iWfj","checkbox":"LoginUser_checkbox__2Ajzr","button":"LoginUser_button__1GYpx","button2":"LoginUser_button2__3sGTJ"};